import { render, staticRenderFns } from "./KImg.vue?vue&type=template&id=40bbab06&scoped=true"
import script from "./KImg.vue?vue&type=script&lang=js"
export * from "./KImg.vue?vue&type=script&lang=js"
import style0 from "./KImg.vue?vue&type=style&index=0&id=40bbab06&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "40bbab06",
  null
  
)

export default component.exports